import { FormatoDoNumero } from '../../api/radarApi';

/**
 * O ÚNICO lugar que formata o número em destaque de um cartão de radar (transversal/at-82).
 *
 * Existia duas vezes, por cópia — e as duas divergiam: o Radar Financeiro só conhecia `moeda` e
 * `numero`, o do Relacionamento só `percentual` e `numero`. Com o tipo único (`DIV-2` da análise),
 * um radar que passasse a produzir um formato novo renderizaria o número cru na outra tela.
 */
export function formatarNumero(numero: number, formato: FormatoDoNumero): string {
  if (formato === 'moeda') {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numero);
  }

  if (formato === 'percentual') {
    // Uma casa decimal: "36,4%". Sem o limite, uma proporção calculada volta com 13 dígitos.
    return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(numero)}%`;
  }

  return new Intl.NumberFormat('pt-BR').format(numero);
}
